import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  const footerSections = [
    {
      title: "Products",
      links: ["Plumbing Equipment", "Electrical Supplies", "Tools", "New Arrivals", "On Sale"]
    },
    {
      title: "Support",
      links: ["Contact Us", "Shipping Info", "Returns", "Technical Support", "Installation Guides"]
    },
    {
      title: "Company",
      links: ["About Us", "Careers", "Wholesale", "Contractor Program", "Sustainability"]
    }
  ];

  const handleContactClick = () => {
    const phoneNumber = '+254706470670';
    window.open(`tel:${phoneNumber}`, '_self');
  };

  return (
    <footer className="bg-gray-900 text-white pt-20 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand Section */}
          <motion.div
            className="lg:col-span-2"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">K</span>
              </div>
              <span className="text-2xl font-bold">Kassim Hardware</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed max-w-md">
              Your trusted source for professional plumbing and electrical supplies. 
              Quality products, competitive prices and expert support.
            </p>
            <div className="flex space-x-4">
              <motion.button
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-500 transition-colors duration-300 cursor-pointer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleContactClick}
                title="Call +254 706 470670"
              >
                <span className="text-sm">📞</span>
              </motion.button>
              <motion.div
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-green-500 transition-colors duration-300 cursor-pointer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => {
                  const phoneNumber = '254706470670';
                  const message = 'Hello! I want to inquire about products from Kassim Hardware.';
                  window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
                }}
                title="Chat on WhatsApp"
              >
                <span className="text-sm">💬</span>
              </motion.div>
              <motion.div
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-500 transition-colors duration-300 cursor-pointer"
                whileHover={{ scale: 1.1, y: -2 }}
                whileTap={{ scale: 0.95 }}
                title="Email us"
              >
                <span className="text-sm">📧</span>
              </motion.div>
            </div>
            
            {/* Contact Info */}
            <div className="mt-6 space-y-2">
              <div className="flex items-center space-x-2 text-gray-400">
                <span>📞</span>
                <span>+254 706 470670</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-400">
                <span>📍</span>
                <span>Kakamega Municipality</span>
              </div>
            </div>
          </motion.div>

          {/* Footer Links */}
          {footerSections.map((section, sectionIndex) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: sectionIndex * 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="font-bold text-lg mb-6 text-white">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <motion.li key={link}>
                    <a
                      href="#"
                      className="text-gray-400 hover:text-white transition-colors duration-300 hover:pl-2 block"
                      initial={{ opacity: 0, x: -10 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.4, delay: (sectionIndex * 0.1) + (linkIndex * 0.05) }}
                      viewport={{ once: true }}
                    >
                      {link}
                    </a>
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Bottom Bar */}
        <motion.div
          className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-400 text-sm">
            © 2024 Kassim Hardware. All rights reserved.
          </p>
          
          {/* Developer Credit - With always visible orange underline */}
          <motion.div
            className="text-center md:text-right"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <a
              href="https://martindev.co.ke"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-orange-500 transition-colors duration-300 text-sm font-light underline decoration-orange-500 decoration-1 hover:decoration-2"
            >
              Developer : <span className="font-medium">martindev.co.ke</span>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
